import { FC } from 'react';
import { mildangFirebaseAnalytics } from '@ui/utils/SALogEvent/mildangFirebase';
import FindAccountsDialog from '@ui/components/user/patterns/FindEmailDialog/FindEmailDialog';
import useErrorSnakbar from 'hooks/useErrorSnakbar';

interface IFindEmailDialog {
  open: boolean;
  onClose?: () => void;
}

const FindEmailDialog: FC<IFindEmailDialog> = ({ open, onClose }) => {
  const { enqueueApolloError } = useErrorSnakbar();

  return (
    <>
      <FindAccountsDialog
        open={open}
        onClose={onClose}
        onCloseClick={onClose}
        onSubmitError={(e) => enqueueApolloError(e as any)}
        onSubmitProp={(formData) => {
          mildangFirebaseAnalytics.logEvent('findAcount_btn', {
            name: formData.name,
            phoneNumber: formData.phoneNumber,
          });
        }}
      />
    </>
  );
};

export default FindEmailDialog;
